module.exports = __webpack_public_path__ + "static/img/Q.12baf36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f2/Q.png
// module id = Bke1
// module chunks = 0